import { Component } from '@angular/core';

@Component({
  selector: 'ncp-create',
  imports: [],
  templateUrl: './create.component.html',
  styleUrl: './create.component.scss',
})
export class CreateComponent {

}
